export default "__VITE_ASSET__0Y3S1lsx__"